import { colorSchemes } from '@features/campaigns/subdomains/visitation/utils/color-schemes';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';

type ColumnHeaderProps = {
  icon?: FontAwesomeIconProps['icon'];
  headerName: string;
  color: keyof typeof colorSchemes;
};

export const ColumnHeader = (props: ColumnHeaderProps) => {
  const colorScheme = colorSchemes[props.color];
  return (
    <Stack
      direction="row"
      gap="0.5rem"
      alignItems="center"
      borderRadius={2}
      padding="0.375rem"
      overflow="hidden"
      title={props.headerName}
      sx={{
        backgroundColor: colorScheme.background,
        height: '100%',
      }}
    >
      {props.icon ? (
        <FontAwesomeIcon icon={props.icon} color={colorScheme.text} />
      ) : null}

      <Typography textOverflow="ellipsis" overflow="hidden">
        {props.headerName}
      </Typography>
    </Stack>
  );
};
